import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

const RefurbishmentBreadCrumbs: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs>
      <Crumb data-testid='crumb-refurbishment-home' key='crumb-refurbishment-home' path='/forms' text={t('Refurbishment.Home')} />
      <Crumb
        data-testid='crumb-refurbishment-testingdieselparts'
        key='crumb-refurbishment-testingdieselparts'
        path='/forms/testingdieselparts/:uuid'
        text={t('Refurbishment.TestingDieselParts')}
      />
      <Crumb
        data-testid='crumb-refurbishment-cleaningfilter'
        key='crumb-refurbishment-cleaningfilter'
        path='/forms/cleaningtheparticulatefilter/:uuid'
        text={t('Refurbishment.CleaningFilter')}
      />
    </Breadcrumbs>
  )
}

export default RefurbishmentBreadCrumbs
